import React from 'react';
import { FormProvider } from 'react-hook-form';
import { CustomerType, DraftAccountDTO, FORM_WIDTH } from '../../AccountOpening.meta';
import { EmploymentStatus } from '../../fields/EmploymentStatus/EmploymentStatus';
import { AnnualIncome } from '../../fields/NetWorthFields/AnnualIncome/AnnualIncome';
import { LiquidNetWorth } from '../../fields/NetWorthFields/LiquidNetWorth/LiquidNetWorth';
import { TotalNetWorth } from '../../fields/NetWorthFields/TotalNetWorth/TotalNetWorth';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';
import { Footer } from '../../components/Footer/Footer';
import { Alert } from '../../../../CommonComponents/OPL/Alert/Alert';
import { validation } from './Employment.meta';
import { useStepForm } from '../../hooks/useStepForm';
import { StepCard } from '../../components/StepCard/StepCard';
import { StepContent } from '../../components/StepContent/StepContent';

interface Props {
  draftAccount: DraftAccountDTO;
  onSuccess(): void;
  onPrevious?(): void;
}

export const Employment: React.FC<Props> = ({ draftAccount, onSuccess, onPrevious }) => {
  const { formBag, saveDraftMutation, onSubmit } = useStepForm({
    draftAccount,
    onSuccess,
    validation,
  });

  return (
    <FormProvider {...formBag}>
      <form onSubmit={formBag.handleSubmit(onSubmit)}>
        <StepContent>
          <StepCard maxWidth={FORM_WIDTH}>
            <Text fontSize="h5" fontWeight={600}>
              Employment information
            </Text>

            {saveDraftMutation.error && (
              <Alert message={saveDraftMutation.error.message} variant="error" mt="32" />
            )}

            <EmploymentStatus fieldName="primaryApplicant" draftAccount={draftAccount} mt="32" />

            <AnnualIncome draftAccount={draftAccount} mt="32" />

            <LiquidNetWorth draftAccount={draftAccount} mt="32" />

            <TotalNetWorth draftAccount={draftAccount} mt="32" />
          </StepCard>

          {draftAccount.customerType === CustomerType.Joint && (
            <StepCard maxWidth={FORM_WIDTH} mt="24">
              <Text fontSize="h5" fontWeight={600}>
                Your partner&apos;s employment information
              </Text>

              <EmploymentStatus fieldName="secondApplicant" draftAccount={draftAccount} mt="32" />
            </StepCard>
          )}
        </StepContent>

        <Footer isLoading={saveDraftMutation.isLoading} onPrevious={onPrevious} />
      </form>
    </FormProvider>
  );
};
